export interface KnowledgeLesson {
  id: number;
  title: string;
  content: string;
  emoji: string;
  tip: string;
}

export interface RoundProps {
  onComplete: (success: boolean, points: number) => void;
  bacteriaLevel: number;
  setBacteriaLevel: (v: number) => void;
  cleanLevel: number;
  setCleanLevel: (v: number) => void;
}

// 11 lessons (lesson id 2 = PhanLoaiThucPham is used in KnowledgeTest at end)
export const KNOWLEDGE_LESSONS: KnowledgeLesson[] = [
  {
    id: 0,
    title: 'Chọn đúng dụng cụ nấu ăn',
    content: 'Hãy lựa chọn đúng dụng cụ và hỏi ý kiến của người lớn để giúp nấu ăn an toàn và hiệu quả. Không dùng những món đồ như đồ chơi hay bút để nấu ăn nhé!',
    emoji: '🍳',
    tip: 'Chỉ dùng dụng cụ đúng mục đích để nấu ăn an toàn nhé các bạn!'
  },
  {
    id: 1,
    title: 'Chọn nguyên liệu sạch, an toàn',
    content: 'Gạo nếp phải trắng sạch, không mốc, không mọt. Nước phải trong sạch. Ống nứa vừa đủ tuổi, không nứt. Lá chuối phải rửa sạch trước khi dùng!',
    emoji: '🛒',
    tip: 'Nhìn kỹ từng nguyên liệu trước khi dùng — nguyên liệu bẩn sẽ gây bệnh!'
  },
  {
    id: 2,
    title: 'Nhận biết thực phẩm sạch và bẩn',
    content: 'Thực phẩm sạch: tươi, không mùi, không bị hỏng. Thực phẩm bẩn: có mọt, mốc, thiu, quá hạn. Ăn thực phẩm bẩn có thể bị đau bụng, ngộ độc!',
    emoji: '🔍',
    tip: 'Luôn kiểm tra kỹ thực phẩm trước khi dùng để bảo vệ sức khỏe!'
  },
  {
    id: 3,
    title: 'Rửa tay đúng cách trước khi nấu',
    content: 'Rửa tay đầy đủ 7 bước: Kéo tay vào vòi → Mở vòi → Xà phòng → Chà kỹ → Chà kẽ tay → Rửa sạch → Lau khô. Thiếu bước nào vi khuẩn vẫn còn!',
    emoji: '🙌',
    tip: 'Chà tay ít nhất 20 giây với xà phòng để diệt hết vi khuẩn!'
  },
  {
    id: 4,
    title: 'Rửa sạch dụng cụ trước khi dùng',
    content: 'Ống nứa và dụng cụ từ rừng hoặc ngoài trời có bụi bẩn và vi khuẩn. Cần rửa kỹ từng bước: ngâm, xà phòng, chà, tráng sạch, để ráo.',
    emoji: '🎋',
    tip: 'Chà mạnh tay những chỗ có vết bẩn và để ráo hoàn toàn mới dùng!'
  },
  {
    id: 5,
    title: 'Vo gạo sạch bằng nước',
    content: 'Gạo chưa vo còn bụi và tạp chất. Vo cho đến khi nước trong hoàn toàn là gạo đã sạch. Thường cần 2-3 lần vo mới ra nước trong!',
    emoji: '🌾',
    tip: 'Nước còn đục → còn bẩn. Nước trong → gạo sạch. Đơn giản vậy thôi!'
  },
  {
    id: 6,
    title: 'Chuẩn bị ống nứa đúng cách',
    content: 'Ống nứa cần rửa sạch, lau khô, nhồi gạo vừa đủ 2/3, đổ nước, đặt lá chuối bịt miệng và khoét lỗ đáy. Thiếu lỗ đáy ống có thể nổ khi nướng!',
    emoji: '🎍',
    tip: 'Nhồi 2/3 ống thôi - gạo sẽ nở ra khi nấu cần có chỗ trống!'
  },
  {
    id: 7,
    title: 'Nhóm lửa cần người lớn giúp',
    content: 'Lửa rất nguy hiểm! Không bao giờ tự nhóm lửa một mình. Người lớn xếp củi và châm lửa, em chỉ thổi nhẹ để giúp than đỏ.',
    emoji: '🔥',
    tip: 'Thổi nhẹ và đều từ xa, không thổi mạnh làm tắt lửa!'
  },
  {
    id: 8,
    title: 'Giữ lửa vừa đủ khi nướng',
    content: 'Lửa quá to → cơm cháy đen. Lửa quá nhỏ → cơm sống. Lửa vừa phải → cơm chín đều, vàng thơm. Thêm bớt củi để điều chỉnh nhiệt!',
    emoji: '🌡️',
    tip: 'Ống nứa chuyển vàng nâu đẹp = đang nướng đúng nhiệt độ!'
  },
  {
    id: 9,
    title: 'Xoay ống đều khi nướng',
    content: 'Xoay ống cơm đều giúp tất cả mặt được nướng chín đều nhau. Không xoay → một mặt cháy đen, một mặt còn sống. Xoay mỗi 30 giây một lần!',
    emoji: '🔄',
    tip: 'Xoay đều như kim đồng hồ - cứ 30 giây xoay một lần!'
  },
  {
    id: 10,
    title: 'Cơm lam chín an toàn - ăn chín uống sôi!',
    content: 'Ăn chín uống sôi là nguyên tắc vàng! Cơm lam chín hoàn toàn mới được ăn. Ăn đồ sống hoặc chưa chín kỹ sẽ bị đau bụng vì vi khuẩn chưa bị tiêu diệt.',
    emoji: '✅',
    tip: 'Cơm lam chín có màu vàng thơm - không trắng (sống) không đen (cháy)!'
  },
];

export interface GameState {
  cleanBar: number;
  bacteriaBar: number;
  cookedBar: number;
  score: number;
  roundIndex: number;
  unlockedLessons: number[];
  showNotebook: boolean;
}
